<template>
  <div class="manage-main-box">
    <Bread :breadConfig="breadConfig" />
    <div class="eol-container-box">
      <div class="search-all-box">
        <a-form-model layout="inline" ref="ruleForm" :model="form">
          <a-form-model-item prop="name">
            <a-input v-model="form.name" class="search-input" placeholder="请输入场馆名称"></a-input>
          </a-form-model-item>
          <a-form-model-item prop="address">
            <a-input v-model="form.address" class="search-input" placeholder="请输入地址"></a-input>
          </a-form-model-item>
          <a-form-model-item prop="category_id">
            <a-select v-model="form.category_id" placeholder="请选择场馆类型" style="width: 160px" class="multiple-select" dropdownClassName="multipleDrop">
              <a-select-option value="">场馆类型</a-select-option>
              <a-select-option v-for="(item, index) in stadiumType" :key="index" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <a-button class="search-btn" type="primary" @click="onSearch()">搜索</a-button>
            <a-button class="reset-btn" @click="resetForm()">重置</a-button>
          </a-form-model-item>
        </a-form-model>
        <div class="right-option-box">
          <a-button class="option-btn" type="primary" @click="addStadium()">添加场馆</a-button>
        </div>
      </div>
      <div class="table-all-box">
        <a-table :columns="columns" :data-source="tableData" rowKey="id" :bordered="false" size="small" :pagination="false">
          <template slot="category_name"  slot-scope="text, scope">
            <div class="erweima-icon" >{{scope.category_name.join(",")}}</div>
          </template>
          <template slot="action" slot-scope="text, scope">
            <a-button type="link" @click="setStudentModal(scope)">场馆信息</a-button>
            <a-button type="link" @click="toArtifact(scope)">文物</a-button>
            <a-button type="link" @click="toCharacter(scope)">人物</a-button>
            <a-button type="link" @click="toShowroom(scope)">线上展厅</a-button>
            <a-button type="link" @click="deleteStudentModal(scope)">删除</a-button>

          </template>
        </a-table>
        <a-pagination class="school-pagination" v-model="page" :total="totalNum" @change="pageChange" show-less-items />
      </div>
      <CommonModal v-model="showDeleteModal" title="删除场馆" confirmText="确定" @confirm="handleDeleteConfirm">
        <div class="delete-modal">
          删除场馆后，场馆的相关信息、内容将同步删除、不可恢复、确定删除吗？
        </div>
      </CommonModal>
      <addStadium v-model="showAddModal" :stadiumId="stadiumId" :title="setModelText" confirmText="确定" @confirm="handaddedConfirm"></addStadium>
    </div>
  </div>

</template>
<script>
import CommonModal from "../../../../components/CommonModal"
import addStadium from "../../../../components/school/addStadium.vue"
import { mapActions ,mapState} from "vuex";
// import services from '../../../../assets/js/services';
import Bread from "../../../../components/school/Bread.vue";
export default {
  name: 'stadiumAddress',
  components: {
    CommonModal,
    addStadium,
    Bread
  },
  data() {
    return {
      breadConfig: [{ name: "场馆旧址" }],
      school_code: localStorage.getItem("schoolCode"),
      page: 1,
      size: 10,
      totalNum: 0,
      tableData: [],
      form: {
        name: "",
        address: "",
        category_id: '',
      },
      categoryNameList: [
        { id: 1, name: '学生扫码加入' },
        { id: 2, name: '教师添加' },
      ],
      stadiumType: [],
      columns: [
        {
          title: "场馆名称",
          dataIndex: "name",
        },
        {
          title: "场馆类型",
          dataIndex: "category_name",
          scopedSlots: { customRender: 'category_name' },
        },
        {
          title: "场馆地址",
          dataIndex: "address",
        },
        {
          title: "开放时间",
          dataIndex: "open_time",
          // scopedSlots: { customRender: 'source_type' },
        },
        {
          title: "联系电话",
          dataIndex: "mobile",
        },
        {
          title: "更新时间",
          dataIndex: "updated_at",
        },
        {
          title: "更新人",
          dataIndex: "updated_name",
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
      ],
      showDeleteModal: false,
      showAddModal: false,
      setModelText: '添加',
      stadiumId: "",
      deleteId: "",
    };
  },

  mounted() {
        if (!(this.appsUserInfo.user_type == 2 || (this.appsUserInfo.user_type == 1 && this.appsUserInfo.role_ids == 2))) {
      this.$router.push(`/${this.school_code}/school/teach`)
    }
    this.class_id = this.$route.query.cid
    this.setStadiumType()
    this.getTableList()
  },
   computed: {
    ...mapState({
      appsUserInfo: state => state.appsLogin.appsUserInfo,
    }),
  },
  watch: {
    showAddModal: {
      handler(newVal) {
        if (!newVal) {
          this.stadiumId = ""
        }
      }
    }
  },
  methods: {
    ...mapActions(["getStadiumAddress", "addStadiumAddress", "editStadiumAddress", "getStadiumAddressInfo","getStadiumType"]),
    getTableList() {
      let params = {
        page: this.page,
        size: this.size,
        name: this.form.name,
        category_id: this.form.category_id,
        address: this.form.address,
      };
      this.getStadiumAddress(params).then((res) => {
        if (res.code == "0000" && res.data) {
          this.tableData = res.data.items;
          this.totalNum = res.data.total;
          // console.log(res.data)
        }
      });
    },
    onSearch() {
      this.page = 1;
      this.total = 0;
      this.getTableList();
    },
    pageChange(val) {
      this.page = val;
      this.total = 0;
      this.getTableList();
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.onSearch()
    },
    handleModalVisible(key, val) {
      this[key] = val
    },
    handleDeleteConfirm() {
      this.studentDelete({ id: this.deleteId, data: { _method: 'delete' } })
    },
    handaddedConfirm() {
      this.getTableList()
    },
    setStudentModal(item) {
      this.stadiumId = item.id
      this.setModelText = '编辑场馆'
      this.handleModalVisible('showAddModal', true)

    },
    toArtifact(item) {
      this.$router.push({ path: `/${this.school_code}/school/hsjr/artifact`, query: { venue_id: item.id } })
    },
    toCharacter(item) {
      this.$router.push({ path: `/${this.school_code}/school/hsjr/character`, query: { venue_id: item.id } })
    },
    toShowroom(item) {
      this.$router.push({ path: `/${this.school_code}/school/hsjr/showroom`, query: { venue_id: item.id } })
    },
    addStadium() {
      this.setModelText = '添加场馆'
      this.handleModalVisible('showAddModal', true, null)

    },

    // 表格中 删除按钮 点击事件
    deleteStudentModal(item) {
      this.deleteId = item.id
      this.delType = 1
      this.handleModalVisible('showDeleteModal', true)
    },
    // 班级添加和删除方法
    studentDelete(params) {
      this.editStadiumAddress(params).then(res => {
        if (res.code == "0000") {
          this.studentId = ''
          this.$message.success(`删除成功`)
          this.handleModalVisible('showDeleteModal', false)
          this.resetForm()
        } else {
          this.$message.error(res.message)
        }
      })
    },
     setStadiumType() {
      this.getStadiumType({
        page: 1,
        size: 100,
      }).then((res) => {
        if (res.code == "0000" && res.data) {
          this.stadiumType = res.data.items.map(item => {
            return {
              name: item.name,
              id: item.id,
            }
          })
        }
      });
    },


  },
};
</script>

<style lang="less" scoped>
.back-class-btn {
  padding: 0 16px;
  height: 32px;
  background: #b84b3c;
  border-radius: 16px;
  font-weight: bold;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  margin-bottom: 15px;
  line-height: 32px;
  &:hover {
    background: #a82822;
  }
}
.delete-modal {
  font-weight: bold;
  font-size: 16px;
  color: #373536;
  text-align: center;
}
.choose-modal {
  padding-top: 20px;
}
</style>